import { render, staticRenderFns } from "./ManagersPage.vue?vue&type=template&id=cbf87b94"
import script from "./ManagersPage.vue?vue&type=script&lang=js"
export * from "./ManagersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports